export default __webpack_public_path__ + "static/media/안주4.d533ace5.jpg";